/** Define common colors, fonts, and other branding here */
const colors = {
  white: '#fff',
  black: '#000',
  grey: '#9FA4A2',

  /** Brand colors */
  briangerine: '#E55427',
  merciless: '#373A36',
  kyleberry: '#A13122',
  drizzleberry: '#4194AA',
  sizzle: '#7DE9F8',
  yarmieGreen: '#D1E74D',
  limestone: '##EBEBE2',
  officePutty: '#D1D1C6',
  darkChocolate: '#413B3A',
  chocolateMilk: '#5D5653',
  neutralAF: '#8A7379',

  /** Data visualization colors */
  mimosa: '#ED844F',
  dreamsicle: '#F5C1AD',
  fnPeachy: '#FAE6D6',
  citron: '#E1FF00',
  lemonjuice: '#F2FAAE',
};

const charts = [
  colors.mimosa,
  colors.lemonjuice,
  colors.dreamsicle,
  colors.citron,
];

/** These all need the same keys so each themed section can expect them */
const sectionThemes = {
  default: {
    primary: colors.briangerine,
    secondary: colors.merciless,
    highlight1: colors.merciless,
    highlight2: colors.merciless,
    highlight3: colors.merciless,
    highlight4: colors.merciless,
    charts: [
      colors.mimosa,
      colors.dreamsicle,
      colors.citron,
      colors.lemonjuice,
    ],
  },
};

const fonts = {
  serif: 'serif',
  sansSerif: 'sans-serif',
  galanoGrotesque: '"Galano Grotesque Alt", Helvetica, Arial, sans-serif',
};

const sizes = {
  containerWidthSlim: '72rem',
  containerWidth: '110rem',
};

const breakpoints = {
  small: `screen and (max-width: 35em)`,
  smallMin: `screen and (min-width: 35em)`,
  medium: `screen and (max-width: 64em)`,
  large: `screen and (max-width: 96em)`,
  xlarge: `screen and (max-width: 110em)`,
  minHeight: `screen and (max-height: 37em)`,
};

const shadows = {
  primary: '0 0.2em 0.3em 0 rgba(0, 0, 0, .1)',
};

const animations = {
  ease: '.3s ease-in-out',
  smoothTransitionBezier: '.4s cubic-bezier(0.11, 0.59, 0.32, 0.9)',
};

const theme = {
  colors,
  charts,
  fonts,
  sizes,
  breakpoints,
  shadows,
  animations,
  /**
   * Assign each theme item so we can pick a primary color scheme per section.
   * We can also access each item per section individually in case we want to
   * do some overrides
   */
  ...sectionThemes,
};

export default theme;
